import { ScaffoldSpecificationWebConsoleData } from './scaffold-specification-web-console-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class CreateScaffoldWebConsoleCommand {
  ScaffoldId: string;
  ScaffoldStatusId: string;
  SpecificLocationDetails: string;
  AdverseWeatherIndicator: boolean;
  SiteAreaId: string;
  ScaffoldNumber: string;
  ContractId: string;
  DateOfNextInspection: string;
  ScaffoldSpecification: ScaffoldSpecificationWebConsoleData;
  OffsetFromUtc: number;
  OnHireDate: string;
  ItemId: string;
}


